import { Fragment } from 'react';
import { Separator } from '@parrot-software/design-system';

/** One label/value line of a confirmation summary — values arrive already formatted. */
export type ConfirmationSummaryRow = {
  label: string;
  value: string;
};

type ConfirmationSummaryRowsProps = {
  rows: ConfirmationSummaryRow[];
};

/**
 * Separator-divided label/value rows shared by the card confirmation variants
 * (`card-saved`, `payment-done`, `card-updated`) of wizard step 5.
 *
 * @param props.rows - Ordered summary rows (label left, formatted value right)
 * @returns React element rendering the summary rows
 */
export const ConfirmationSummaryRows = ({ rows }: ConfirmationSummaryRowsProps) => (
  <div className="flex w-full flex-col gap-3">
    {rows.map((row, index) => (
      <Fragment key={row.label}>
        {index > 0 && <Separator />}
        <div className="flex items-start justify-between gap-1 text-sm leading-5">
          <span className="text-muted-foreground">{row.label}</span>
          <span className="font-semibold text-foreground">{row.value}</span>
        </div>
      </Fragment>
    ))}
  </div>
);
